"use client";

import Link from "next/link";
import Image from "next/image";
import { useAuth } from "@/context/AuthContext";
import { useEffect, useState } from "react";
import TopNavBar from "./navbar/TopNavBar";
import MainNavigation from "./navbar/MainNavigation";
import UserActions from "./navbar/UserActions";
import MobileMenu from "./navbar/MobileMenu";

export default function Navbar() {
  const { user, isAuthenticated, isAdmin, logout } = useAuth();
  const [isTopNavVisible, setIsTopNavVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Handle scroll to hide/show top nav
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsTopNavVisible(false);
      } else if (currentScrollY < lastScrollY) {
        setIsTopNavVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <>
      {/* Top Navigation Bar */}
      {/* <TopNavBar isVisible={isTopNavVisible} /> */}

      {/* Main Navigation */}
      <header className="bg-white sticky top-0 z-50 border-b border-gray-200 w-full">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-0">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <div onClick={() => window.location.href = "/"} className="flex items-center flex-shrink-0 cursor-pointer">
              <div className="relative w-[220px] h-[80px]">
                <Image
                  src="/logo/logo.svg"
                  alt="RR Equipment Rentals Logo"
                  fill
                  priority
                  className="object-contain"
                  sizes="(max-width: 768px) 180px, 220px"
                />
              </div>
            </div>

            {/* Desktop Navigation - Right Aligned */}
            <div className="hidden lg:flex items-center space-x-8 h-full">
              <MainNavigation
                isAuthenticated={isAuthenticated}
                isAdmin={isAdmin}
              />
              {/* Only show user actions for admin users */}
              {isAdmin && (
                <UserActions
                  isAuthenticated={isAuthenticated}
                  isAdmin={isAdmin}
                  user={user}
                  logout={logout}
                />
              )}
            </div>

            {/* Mobile Menu */}
            <MobileMenu
              isAuthenticated={isAuthenticated}
              isAdmin={isAdmin}
              user={user}
              logout={logout}
            />
          </div>
        </div>
      </header>
    </>
  );
}
